import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { List } from 'immutable';
import { PaymentProvidersType } from 'src/AppState/ConfigState/types';
import { WithdrawProcedureState } from 'src/components/WithdrawProcedure/WithdrawProcedure.state';
import { WithdrawForm } from 'src/components/WithdrawForm/realex/WithdrawForm';
import { WithdrawFormPaysafe } from 'src/components/WithdrawForm/paysafe/WithdrawForm';
import { YaspaState } from 'src/components/WithdrawForm/yaspa/YaspaSegment.state';
import { useAppStateContext } from 'src/AppState/AppState';
import { YaspaPopup } from 'src/components/WithdrawForm/yaspa/YaspaPopup';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

interface WithdrawProcedurePropsType {
    customerId: number;
    permissionGrants: List<unknown>;
    usePaymentFormForUniverse: PaymentProvidersType;
    onQueryAudits: () => void;
}

export const WithdrawProcedure = observer(
    'WithdrawProcedure',
    ({ customerId, permissionGrants, usePaymentFormForUniverse, onQueryAudits }: WithdrawProcedurePropsType) => {
        const { common, models } = useAppStateContext();
        const { staffWithdrawalCardProvider } = ConfigState.get(common).config;
        const [state] = useState(() => new WithdrawProcedureState(permissionGrants));
        const [yaspaStateMap] = useState(
            new AutoMap((customerId: number) => new YaspaState(customerId, common, models, onQueryAudits))
        );
        const yaspaState = yaspaStateMap.get(customerId);

        const provider = (): JSX.Element => {
            // Withdraw to a saved card of this provider; for Worldpay, Manual Withdrawals then sends the payout.
            if (staffWithdrawalCardProvider !== null) {
                return (
                    <WithdrawForm
                        permisionsAllowed={state.hasWithdrawalsPermission}
                        customerId={customerId}
                        submitCallback={onQueryAudits}
                        yaspaState={yaspaState}
                        paymentProvider={{ type: staffWithdrawalCardProvider, openBanking: null }}
                    />
                );
            }

            switch (usePaymentFormForUniverse.type) {
                case 'realex':
                case 'multi-deposit':
                    return (
                        <WithdrawForm
                            permisionsAllowed={state.hasWithdrawalsPermission}
                            customerId={customerId}
                            submitCallback={onQueryAudits}
                            yaspaState={yaspaState}
                        />
                    );
                case 'paysafe':
                    return (
                        <WithdrawFormPaysafe
                            permisionsAllowed={state.hasWithdrawalsPermission}
                            customerId={customerId}
                            submitCallback={onQueryAudits}
                            yaspaState={yaspaState}
                        />
                    );
                default:
                    return <div data-test='withdraw-support-info'>Not supported</div>;
            }
        };

        return (
            <>
                {provider()}
                <YaspaPopup yaspaState={yaspaState} />
            </>
        );
    }
);
